<template>
  <dropdown class="user-menu ivu-dropdown--arrow" placement="bottom" trigger="click">
    <a href="javascript:void(0)">{{ $user.name }}</a>
    <dropdown-menu slot="list">
      <dropdown-item class="p-0">
        <router-link
          class="w-100 ivu-dropdown-item user-menu__item user-menu__item--profile"
          :to="{ name: 'core.profile' }"
        >
          {{ $t('core.breadcrumb.profile') }}
        </router-link>
      </dropdown-item>

      <dropdown-item class="p-0">
        <router-link
          class="w-100 ivu-dropdown-item user-menu__item user-menu__item--prices"
          :to="{ name: 'core.price.index' }"
        >
          {{ $t('core.breadcrumb.price.index') }}
        </router-link>
      </dropdown-item>

      <dropdown-item class="p-0">
        <router-link
          class="w-100 ivu-dropdown-item user-menu__item user-menu__item--payments"
          :to="{ name: 'core.payment.index' }"
        >
          {{ $t('core.breadcrumb.payment.index') }}
        </router-link>
      </dropdown-item>

      <dropdown-item class="p-0">
        <router-link
          class="w-100 ivu-dropdown-item user-menu__item user-menu__item--docs"
          :to="{ name: 'core.document.index' }"
        >
          {{ $t('core.breadcrumb.document.index') }}
        </router-link>
      </dropdown-item>

      <dropdown-item class="p-0">
        <router-link
          class="w-100 ivu-dropdown-item ivu-dropdown-item-divided user-menu__item user-menu__item--logout"
          to="#"
          @click.native.prevent="logout"
        >
          {{ $t('core.breadcrumb.logout') }}
        </router-link>
      </dropdown-item>
    </dropdown-menu>
  </dropdown>
</template>

<script>
  export default {
    methods: {
      logout: function() {
        this.$store
          .dispatch('core/auth/logout')
          .then(() => this.$nextTick(() => window.location.reload()));
      }
    }
  };
</script>

<style lang="scss">
  .user-menu {
    .ivu-dropdown-rel a {
      padding: 0 20px;
      padding-left: 60px;

      background-image: url('/img/icons/header/user.svg');
      background-size: 20px 20px;
      background-repeat: no-repeat;
      background-position: 22px center;

      font-size: 15px;
      color: $blue-grey-light;

      &:hover {
        text-decoration: none;
        color: #ffffff;
      }
    }

    .ivu-dropdown-item {
      height: 44px;
      font-size: 14px !important;
      display: flex;
      align-items: center;

      padding-right: 16px;
      padding-left: 16px;
      padding-top: 0;
      padding-bottom: 0;
      color: $blue-grey-light;
    }

    .user-menu__item {
      background-repeat: no-repeat !important;
      background-size: 17px !important;
      background-position: 16px center !important;
      padding-left: 45px !important;
      text-decoration: none !important;

      &.ivu-dropdown-item-divided:before {
        margin: 0;
      }

      $items: 'docs', 'logout', 'payments', 'profile', 'prices';

      @each $item in $items {
        &.user-menu__item--#{$item} {
          background-image: url('/img/icons/header/menu/#{$item}.svg');
        }
      }

      &.user-menu__item--profile {
        background-size: 16px !important;
      }

      &.user-menu__item--prices {
        background-size: 19px !important;
      }

      &.user-menu__item--docs {
        background-size: 15px !important;
      }
    }
  }
</style>
